import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import styles from "styles/public.module.css";

function AuthFormActions({
  submitLabel,
  isProcessing,
  onCancel,
  cancelLabel = "Cancel",
}) {
  return (
    <div className={styles["form-actions"]}>
      {isProcessing ? (
        <LoadingButton
          loading
          variant="contained"
          className={styles["primary-action"]}
        >
          {submitLabel}
        </LoadingButton>
      ) : (
        <Button
          type="submit"
          variant="contained"
          className={styles["primary-action"]}
        >
          {submitLabel}
        </Button>
      )}
      {onCancel ? (
        <Button
          type="button"
          variant="outlined"
          className={styles["secondary-action"]}
          onClick={onCancel}
          disabled={isProcessing}
        >
          {cancelLabel}
        </Button>
      ) : null}
    </div>
  );
}

export default AuthFormActions;
